export default __webpack_public_path__ + "static/media/crude-table.eeb43227.svg";